import Backbone from 'backbone'
import config from '../config'
import NavItemView from './nav-item'
import user from '../user'

const NavView = Backbone.View.extend({
    tagName: 'ul',
    initialize() {
        this.listenTo(config, 'change', this.render)
        this.listenTo(user, 'change', this.render)
        this.listenTo(user.get('school'), 'change', this.render)
        this.listenTo(user.get('role'), 'change', this.render)
    },
    render() {
        // clear this view
        this.$el.html('')

        // append relevant nav buttons
        config.get('navItems').each((navItemModel) => {
            // if the route requires the school to be false and there is one return false
            if (navItemModel.get('school') === false && user.get('school').get('id') !== null) return false

            // if the route is not supported on handheld devices return false
            if (config.get('handheld') && navItemModel.get('handheld') === false) return false

            // if the book route make sure there is an open app
            if (config.get('id') === null && navItemModel.get('name') === 'contents') return false

            // if the reporting route make sure there are tests
            if (config.get('testAvailable') === false && navItemModel.get('name') === 'reporting') return false

            // if it is a school route make sure the app is not loaded
            if (config.get('id') !== null && ['school', 'create school', 'join school'].includes(navItemModel.get('name'))) return false

            if (navItemModel.get('type').indexOf(user.get('type').get('name')) === -1 &&
                navItemModel.get('role').indexOf(user.get('role').get('name')) === -1) {
                // check the users type and role are allowed to see this route

                const navItemView = new NavItemView({model: navItemModel})
                this.$el.append(navItemView.render().el)
            }
        })

        return this
    }
})

export default NavView
